import { defineStore } from 'pinia';
// import stores from '🔗/stores';
import { baseUrl, delay } from '🔗/utils/utils';
import { VIBROSONG_PATTENS } from '🔗/constants';

// Формируем карту файлов с иконоками
const spriteModules = import.meta.glob('🔗/themes/**/*.svg', { 
    query: '?url', 
    import: 'default', 
    eager: true 
});
const firstKey = Object.keys(spriteModules)[0] || '';
const basePath = firstKey.substring(0, firstKey.indexOf('/themes')); 

const useOthersStore = defineStore('others', {
    state: () => ({
        ready: false,
        pageReady: null
    }),
    getters: {
        theme: (state) => {
            return stores.settings().theme || stores.messengers().theme;
        },
        themePath: (state) => {
            if (state.theme === 'dark') {
                return new URL(`🔗/themes/dark/variables.css?v=3`, import.meta.url).href;
            }

            return new URL(`🔗/themes/light/variables.css?v=3`, import.meta.url).href;
        },
        getSvgSpriteUrl: (state) => (spriteName) => {
            const theme = state.theme === 'dark' ? 'dark' : 'light';

            const key = `${basePath}/themes/${theme}/svg-sprite/${spriteName}.svg`;
            
            return spriteModules[key] || '';
        }
    },
    actions: {
        setReady(payload) {
            this.ready = payload;
        },
        setPageReady(payload) {
            this.pageReady = payload;
        },
        vibrate(mode) {
            if (!stores.settings().vibration) {
                return;
            }

            if (!stores.messengers().vibrate) {
                return
            }

            stores.messengers().vibrate(mode);
        },
        async vibroSong(name) {
            if (!VIBROSONG_PATTENS[name]) {
                return;
            }

            if (!stores.settings().vibration) {
                return;
            }

            if (!stores.messengers().vibrate) {
                return
            }

            const pattern = VIBROSONG_PATTENS[name];

            for (const step of pattern) {
                stores.messengers().vibrate(step.mode);

                if (step.duration > 0) {
                    await delay(step.duration);
                }
            }
        }

    }
});

export default useOthersStore;
